import { Card, Tabs } from "antd";
import CustomHeader from "../common/Header";
import { HotelAnalytics } from "./Analytics";
import { AverageStayAnalytics } from "./AverageStayAnalytics";
import { CheckInAnalytics } from "./CheckInAnalytics";
import { ErrorAnalytics } from "./ErrorAnalytics";
import { GuestAnalysis } from "./GuestAnalysis";
import { MaxStayAnalytics } from "./MaxStayAnalytics";

const { TabPane } = Tabs;
function Analytics() {
    return (
        <Card>
            <CustomHeader />
            <Tabs type="card" destroyInactiveTabPane>
                <TabPane key={1} tab="Hotel Analytics">
                    <HotelAnalytics />
                </TabPane>
                <TabPane key={2} tab="Check In Analytics">
                    <CheckInAnalytics />
                </TabPane>
                <TabPane key={3} tab="Error Analytics">
                    <ErrorAnalytics />
                </TabPane>
                <TabPane key={4} tab="Guest Analytics">
                    <GuestAnalysis />
                </TabPane>
                <TabPane key={5} tab="Max Stay Analytics">
                    <MaxStayAnalytics />
                </TabPane>
                <TabPane key={6} tab="Average Stay Analytics">
                    <AverageStayAnalytics />
                </TabPane>
            </Tabs>
        </Card>
    );
}

export { Analytics };
